import * as Factory from 'factory.ts'
import faker from 'faker'

import { ApproverConstructorFactory } from '@webapp/core/entities/internal/Approver'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  ExpenseApprovalLog,
  type ExpenseApprovalLogConstructor,
} from './ExpenseApprovalLog'
import { ExpenseApprovalActions } from '../enums/ExpenseApprovalActionEnum'

export const ExpenseApprovalLogConstructorFactory =
  Factory.Sync.makeFactory<ExpenseApprovalLogConstructor>({
    id: Factory.each(() => faker.random.number()),
    action: ExpenseApprovalActions.REQUEST,
    dateTime: Factory.each(() => faker.date.past().toISOString()),
    user: Factory.each(() => ApproverConstructorFactory.build()),
  })

export const ExpenseApprovalLogFactory = EntityFactory(
  ExpenseApprovalLog,
  ExpenseApprovalLogConstructorFactory
)
